import React from "react";
import { Box, Heading, Link, Flex } from "theme-ui";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import CardSlider from "./CardSlider";
import { typography } from "../../styles/theme";

const Logo = ({ url, logo, alt }) => {
	const imageComponent = (
		<GatsbyImage
			image={getImage(logo)}
			alt={"" + alt}
			height="3rem"
		/>
	);

	return (
		<Flex sx={styles.logoWrapper}>
			{url ? (
				<Link
					href={url}
					target="_blank"
					rel="noopener noreferrer"
				>{imageComponent}</Link>
			) : (imageComponent)}
		</Flex>
	);
};

const CarouselBox = ({ data }) => {
	return (
		<Box sx={styles.carouselBox}>
			<CardSlider
				arrows={false}
				autoPlay={true}
				itemClass="carouselItem"
			>
				{data?.map((l, i) => {
					if (l?.logo) {
						return (
							<Logo
								key={`featuredIn-${i}`}
								logo={l?.logo}
								url={l?.url}
								alt={l?.alt ?? l?.logo?.alt}
							/>
						);
					}
				})}
			</CardSlider>
		</Box>
	);
};

const FeaturedLogos = ({ data, showInCarousel = false, heading, customStyles }) => {
	return (
		<Box sx={{...styles.wrapper, ...customStyles}}>
			{heading && <Heading
				as="h2"
				sx={{ ...typography.h2, mb: "3rem" }}
			>
				{heading}
			</Heading>}
			{showInCarousel ? (
				<CarouselBox data={data} />
			) : (
				<Flex sx={styles.logoContainer}>
					{data?.map((l, i) => {
						if (l?.logo) {
							return (
								<Logo
									key={`logo-${i}`}
									logo={l?.logo}
									url={l?.url}
									alt={l?.alt ?? l?.logo?.alt}
								/>
							);
						}
					})}
				</Flex>
			)}
		</Box>
	);
};

const styles = {
	wrapper: {
		my: [5, 5, "7rem", "7rem"],
		textAlign: "center",
	},
	logoContainer: {
		gap: ["1.5rem", "1.5rem", "1.5rem", "3rem"],
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
	},
	logoWrapper: {
		justifyContent: "center",
	},
	carouselBox: {
		".carouselItem": {
			width: "max-content !important",
			mx: "1.5rem"
	}
	}
};

export default FeaturedLogos;
